import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MyAccountContainer } from '@components/organisms/MyAccountContainer';
import { WorkerForm } from '@components/molecules/WorkerForm';
import { SITE_URLS } from '@constants';
import { usePermissionChecker, UserPermissions } from '@hooks/useHasPermission';
import { useCustomNavigate } from '@hooks/useCustomNavigate';
import { useData } from '@hooks/useData';
import { useParams } from 'react-router';

export const ManageWorkersEdit: FC = () => {
    const { navigate } = useCustomNavigate();
    const { store } = useParams();
    const { can } = usePermissionChecker();
    const { myAccountWorkerDetail } = useData();
    const { t } = useTranslation();

    const translations = {
        title: t('manage-workers-edit-component.title', { name: myAccountWorkerDetail?.data?.name || '' }),
    };

    // if user does not have permission accessMerchantAreas, he can't access this page
    useEffect(() => {
        if (can(UserPermissions.accessMerchantAreas) === false) {
            navigate(`/${SITE_URLS.myProfile}`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <MyAccountContainer title={translations.title}>
            <div className="pt-4">
                <WorkerForm edit={true} storeUuid={store ?? ''} />
            </div>
        </MyAccountContainer>
    );
};
